(function () {
  var burger = document.querySelector("[data-tv-burger]");
  var nav = document.querySelector("[data-tv-nav]");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
  }

  document.querySelectorAll("[data-tv-slider]").forEach(function (slider) {
    var track = slider.querySelector("[data-tv-track]");
    var view = slider.querySelector("[data-tv-view]");
    if (!track || !view) return;
    var index = 0;
    function step() {
      var slide = track.querySelector(".tv-slide");
      return slide ? slide.getBoundingClientRect().width + 10 : 300;
    }
    function maxIndex() {
      var vis = Math.max(1, Math.floor(view.clientWidth / step()));
      return Math.max(0, track.children.length - vis);
    }
    function go(n) {
      index = Math.max(0, Math.min(maxIndex(), n));
      track.style.transform = "translateX(" + (-index * step()) + "px)";
    }
    var prev = slider.querySelector("[data-tv-prev]");
    var next = slider.querySelector("[data-tv-next]");
    if (prev) prev.addEventListener("click", function () { go(index - 1); });
    if (next) next.addEventListener("click", function () { go(index + 1); });
  });

  document.querySelectorAll("[data-tv-play]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var media = btn.closest(".tv-creators__media");
      var video = media ? media.querySelector("[data-tv-video]") : null;
      if (!video) return;
      document.querySelectorAll("[data-tv-video]").forEach(function (other) {
        if (other !== video) {
          other.pause();
          var wrap = other.closest(".tv-creators__media");
          if (wrap) wrap.classList.remove("is-playing");
        }
      });
      media.classList.add("is-playing");
      video.setAttribute("controls", "controls");
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    });
  });
  document.querySelectorAll("[data-tv-video]").forEach(function (video) {
    video.addEventListener("ended", function () {
      var media = video.closest(".tv-creators__media");
      if (media) media.classList.remove("is-playing");
      video.removeAttribute("controls");
      video.currentTime = 0;
    });
  });

  document.querySelectorAll("[data-tv-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-tv-gallery-main]");
    gallery.querySelectorAll("[data-tv-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (main) main.src = thumb.getAttribute("data-src");
        gallery.querySelectorAll("[data-tv-gallery-thumb]").forEach(function (el) { el.classList.remove("is-on"); });
        thumb.classList.add("is-on");
      });
    });
  });

  var inside = document.querySelector("[data-tv-inside]");
  if (inside) {
    var jsonEl = inside.querySelector("[data-tv-inside-json]");
    var tabs = inside.querySelector("[data-tv-inside-tabs]");
    var img = inside.querySelector("[data-tv-nf]");
    var ing = inside.querySelector("[data-tv-ing]");
    if (jsonEl && tabs) {
      var data = JSON.parse(jsonEl.textContent);
      var labels = {
        vanilla: "Vanilla", chocolate: "Chocolate", "pumpkin-spice": "Pumpkin Spice",
        "chocolate-peanut-butter": "Chocolate Peanut Butter", unflavored: "Unflavored",
        "vanilla-chai": "Vanilla Chai", strawberry: "Strawberry", "lemon-cookie": "Lemon Cookie",
        "banana-cinnamon": "Banana Cinnamon", matcha: "Matcha", "peanut-butter": "Peanut Butter",
        "chocolate-strawberry": "Chocolate Strawberry"
      };
      Object.keys(data).forEach(function (key, i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = labels[key] || key;
        if (i === 0) btn.className = "is-on";
        btn.addEventListener("click", function () {
          tabs.querySelectorAll("button").forEach(function (b) { b.classList.remove("is-on"); });
          btn.classList.add("is-on");
          var item = data[key];
          if (img) img.src = img.src.replace(/tv-nf-[^/?#]+/, item.image);
          if (ing) ing.textContent = item.items.join(", ") + ".";
        });
        tabs.appendChild(btn);
      });
    }
  }

  var buy = document.querySelector("[data-tv-buy]");
  if (buy) {
    var price = Number((document.querySelector("[data-tv-pdp]") || buy).getAttribute("data-price") || 3799);
    var compare = Number((document.querySelector("[data-tv-pdp]") || buy).getAttribute("data-compare") || 5999);
    var qtys = {};
    function totalQty() {
      var n = 0;
      Object.keys(qtys).forEach(function (k) { n += qtys[k]; });
      return n;
    }
    function rate(n) {
      if (n >= 3) return 0.8;
      if (n >= 2) return 0.9;
      if (n >= 1) return 0.95;
      return 1;
    }
    function money(cents) {
      return "$" + (cents / 100).toFixed(2);
    }
    function render() {
      var n = totalQty();
      var r = rate(n);
      var unit = Math.round(price * r);
      var total = unit * n;
      var was = compare * n;
      buy.querySelectorAll("[data-tv-tiers] button").forEach(function (b) {
        var t = Number(b.getAttribute("data-tier"));
        b.classList.toggle("is-on", (n >= 3 && t === 3) || (n === 2 && t === 2) || (n <= 1 && t === 1));
      });
      var totEl = buy.querySelector("[data-tv-total]");
      var cmpEl = buy.querySelector("[data-tv-compare]");
      var saveEl = buy.querySelector("[data-tv-save]");
      var atc = buy.querySelector("[data-tv-atc]");
      if (cmpEl) cmpEl.textContent = n ? money(was) : money(compare);
      if (totEl) totEl.textContent = money(n ? total : 0);
      if (saveEl) {
        saveEl.hidden = n < 1;
        if (n >= 1) saveEl.textContent = "Save " + Math.round((1 - r) * 100) + "% today";
      }
      if (atc) {
        atc.disabled = n < 1;
        atc.textContent = n < 1 ? "Select at least 1 bag" : "Add to cart";
      }
      buy.querySelectorAll("[data-tv-flavors] li").forEach(function (li) {
        var id = li.getAttribute("data-variant");
        var q = qtys[id] || 0;
        var minus = li.querySelector("[data-tv-minus]");
        var qty = li.querySelector("[data-qty]");
        var plus = li.querySelector("[data-tv-plus]");
        if (minus) minus.hidden = q < 1;
        if (qty) { qty.hidden = q < 1; qty.textContent = q; }
        if (plus) plus.textContent = q < 1 ? "Add" : "+";
      });
    }
    buy.querySelectorAll("[data-tv-plus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.closest("li").getAttribute("data-variant");
        qtys[id] = (qtys[id] || 0) + 1;
        render();
      });
    });
    buy.querySelectorAll("[data-tv-minus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.closest("li").getAttribute("data-variant");
        qtys[id] = Math.max(0, (qtys[id] || 0) - 1);
        render();
      });
    });
    buy.querySelectorAll("[data-tv-tiers] button").forEach(function (b) {
      b.addEventListener("click", function () {
        buy.querySelectorAll("[data-tv-tiers] button").forEach(function (x) { x.classList.remove("is-on"); });
        b.classList.add("is-on");
      });
    });
    var atc = buy.querySelector("[data-tv-atc]");
    if (atc) {
      atc.addEventListener("click", function () {
        var items = Object.keys(qtys).filter(function (id) { return qtys[id] > 0; }).map(function (id) {
          return { id: Number(id), quantity: qtys[id] };
        });
        if (!items.length) return;
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw res;
          return res.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent("tv:open-cart"));
        }).catch(function () {
          window.location.href = "/cart";
        });
      });
    }
    render();
  }

  var drawer = document.querySelector("[data-tv-drawer]");
  if (drawer) {
    var shipGoal = Number(drawer.getAttribute("data-ship-goal") || 5000);
    var moneyFormat = drawer.getAttribute("data-money-format") || "${{amount}}";
    var itemsBox = drawer.querySelector("[data-tv-cart-items]");
    var shipText = drawer.querySelector("[data-tv-ship-text]");
    var shipBar = drawer.querySelector("[data-tv-ship-bar]");
    var subtotalEl = drawer.querySelector("[data-tv-cart-subtotal]");
    var countLabel = drawer.querySelector("[data-tv-cart-count-label]");
    var checkoutBtn = drawer.querySelector("[data-tv-checkout]");
    var badge = document.querySelector("[data-tv-cart-badge]");
    var busy = false;

    function money(cents) {
      var value = (Number(cents || 0) / 100).toFixed(2);
      return String(moneyFormat)
        .replace(/\{\{\s*amount\s*\}\}/g, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents || 0) / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace(".", ","));
    }
    function escapeHtml(str) {
      return String(str || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add("is-open"); });
      document.body.classList.add("tv-drawer-open");
      refreshCart();
    }
    function closeDrawer() {
      drawer.classList.remove("is-open");
      document.body.classList.remove("tv-drawer-open");
      setTimeout(function () { if (!drawer.classList.contains("is-open")) drawer.hidden = true; }, 280);
    }
    function renderCart(cart) {
      var count = cart.item_count || 0;
      var total = cart.total_price || 0;
      var pct = Math.max(0, Math.min(100, Math.round((total / shipGoal) * 100)));
      if (countLabel) countLabel.textContent = count ? "(" + count + ")" : "";
      if (badge) badge.textContent = count;
      if (subtotalEl) subtotalEl.textContent = money(total);
      if (checkoutBtn) checkoutBtn.hidden = count === 0;
      if (shipText) {
        if (count === 0) shipText.textContent = "Add " + money(shipGoal) + " more for free shipping.";
        else if (total >= shipGoal) shipText.textContent = "Free shipping is included on this order.";
        else shipText.textContent = "You're " + money(shipGoal - total) + " away from free shipping!";
      }
      if (shipBar) shipBar.style.width = pct + "%";
      if (!itemsBox) return;
      if (!cart.items || !cart.items.length) {
        itemsBox.innerHTML = '<p class="tv-drawer__empty">Your cart is empty.</p>';
        return;
      }
      itemsBox.innerHTML = cart.items.map(function (item) {
        var img = item.image || "";
        var title = escapeHtml(item.product_title || item.title);
        var key = escapeHtml(item.key);
        var variant = escapeHtml(item.variant_title || "");
        return (
          '<article class="tv-drawer__line" data-key="' + key + '">' +
            '<a class="tv-drawer__thumb" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(img) + '" alt="' + title + '"></a>' +
            '<div class="tv-drawer__info">' +
              '<h3><a href="' + escapeHtml(item.url) + '">' + title + "</a></h3>" +
              "<p>" + variant + " · " + money(item.final_price || item.price) + "</p>" +
              '<div class="tv-qty">' +
                '<button type="button" data-tv-qty-change data-key="' + key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                "<span>" + item.quantity + "</span>" +
                '<button type="button" data-tv-qty-change data-key="' + key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              "</div>" +
              '<button type="button" class="tv-drawer__remove" data-tv-qty-change data-key="' + key + '" data-qty="0">Remove</button>' +
            "</div>" +
            '<p class="tv-drawer__price">' + money(item.final_line_price || item.line_price) + "</p>" +
          "</article>"
        );
      }).join("");
    }
    function refreshCart() {
      return fetch("/cart.js", { credentials: "same-origin" }).then(function (res) { return res.json(); }).then(renderCart);
    }
    function changeQty(key, qty) {
      if (busy) return;
      busy = true;
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: Number(qty) })
      }).then(function (res) { return res.json(); }).then(renderCart).finally(function () { busy = false; });
    }
    document.querySelectorAll("[data-tv-cart-open]").forEach(function (el) {
      el.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
    });
    drawer.querySelectorAll("[data-tv-drawer-close]").forEach(function (el) {
      el.addEventListener("click", closeDrawer);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
    });
    document.addEventListener("tv:open-cart", openDrawer);
    itemsBox.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-tv-qty-change]");
      if (!btn) return;
      changeQty(btn.getAttribute("data-key"), btn.getAttribute("data-qty"));
    });
  }
})();
